export default __webpack_public_path__ + "static/media/choose-account.eee3040f.jpg";